<template>

    <div class="container">

        <div class="my-4">
            <h1>{{ __('Benutzer erstellen') }}</h1>
        </div>

        <div class="row">
            <div class="col-md-6">

                <form @submit.prevent="form.post(route('users.store'))">
                    <form-fields :form="form" :user="user" />
                </form>

            </div>
        </div>

    </div>

</template>

<script>
    import FormFields from './FormFields';

    export default {
        props: [
            'user',
        ],
        data() {
            return {
                form: this.$inertia.form({
                    salutation: null,
                    title: null,
                    first_name: null,
                    last_name: null,
                    email: null,
                    avatar: null,
                    notes: null,
                    password: null,
                    password_confirmation: null,
                }),
            }
        },
        components: {
            FormFields,
        },
        watch: {
        },
        methods: {
        },
    }
</script>